import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState, useEffect } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ImmutableUnderReviewFormControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormControl';
const ReportNotesForm = _ref => {
  let {
    loading,
    onSubmit,
    noteType,
    isImmutableUnderReview = false,
    placeholder,
    setHasUnsavedChanges
  } = _ref;
  const {
    t
  } = useTranslation();
  const [note, setNote] = useState('');
  useEffect(() => {
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(note.trim().length > 0);
    }
  }, [note, setHasUnsavedChanges]);
  const handleSubmit = async () => {
    if (note.trim() === '') return;
    if (onSubmit) {
      await onSubmit({
        note,
        note_type: noteType
      });
    }
    setNote('');
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(false);
    }
  };
  return /*#__PURE__*/React.createElement(InputGroup, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "textarea",
    rows: "3",
    placeholder: placeholder || t('type_a_comment'),
    value: note,
    onChange: e => setNote(e.target.value),
    disabled: loading
  }), /*#__PURE__*/React.createElement(SaveButton, {
    isImmutableUnderReview: isImmutableUnderReview,
    variant: "primary",
    onClick: handleSubmit,
    disabled: note.trim().length === 0 || loading,
    text: loading ? t('saving') : t('save_a_new_comment'),
    className: "ms-1"
  }));
};
export default ReportNotesForm;